export default __webpack_public_path__ + "static/media/List-documentation.5db4e7d8.md";